export function feedbackIn() {
    let lastPageNumber = 7;
    let currentPageNumber = 1;
    let pages = document.querySelectorAll('#FEEDBACK .page');
    let nextButton = document.querySelector('.feedback-footer .next');
    let backButton = document.querySelector('.feedback-footer .back');
    let skipButton = document.querySelector('.feedback-footer .skip');
    let finishButton = document.querySelector('.feedback-footer .finish');
    let form = document.querySelector('#FEEDBACK form');
    let otherTextareaOuter = document.querySelector('#FEEDBACK .other-textarea');
    let positive_action = document.querySelector('#FEEDBACK #input-positive_action');
    let transitioning = false;

    $('select').each(function () {
        //$(this).find('option[value=""]').remove();
        $(this).select2({
            //dropdownParent: $(this).parent(),
            minimumResultsForSearch: -1,
            //allowClear: true, // This option allows the user to clear the selection
            placeholder: '  ',
        });
    });

    nextButton.addEventListener('click', () => {
        changeSubPage(true);
    });
    backButton.addEventListener('click', () => {
        changeSubPage(false);
    });
    finishButton.addEventListener('click', () => {
        changeSubPage(true);
    });

    $('#input-positive_action').on('select2:select', function (e) {
        let positive_action_value = e.params.data.id; // Get the selected value
        if (positive_action_value == 'Other') {
            otherTextareaOuter.classList.remove('disabled');
        } else {
            otherTextareaOuter.classList.add('disabled');
        }
    });

    function changeSubPage(next = true) {
        let nextPageNumber = next ? currentPageNumber + 1 : currentPageNumber - 1;
        let currentPage = document.querySelector(`#FEEDBACK .page[data-page="${currentPageNumber}"]`);
        let pageValid = true;
        if (transitioning) {
            return;
        }
        if (!next && currentPageNumber === 1) {
            return;
        }
        if (next) {
            pageValid = validateCurrentPage();
        }
        console.log('changeSubPage', currentPageNumber, nextPageNumber, pageValid);


        if (!pageValid) {
            return;
        }
        if (next && currentPageNumber == lastPageNumber) {
            form.submit();
        } else {
            fadeOutCurrent(next);
            setTimeout(() => {
                fadeInNext(nextPageNumber)
            }, fadeSpeed);
        }
    }

    function validateCurrentPage() {
        let currentPage = document.querySelector(`#FEEDBACK .page[data-page="${currentPageNumber}"]`);
        let inputs = currentPage.querySelectorAll('input, select, textarea');
        let valid = true;
        inputs.forEach((input) => {
            if (input.name == 'help_in_near_future[]') {
                let checked = false;
                document.querySelectorAll('input[name="help_in_near_future[]"]').forEach((checkbox) => {
                    if (checkbox.checked) {
                        checked = true;
                    }
                });
                if (!checked) {
                    valid = false;
                    let checkboxRows = document.querySelectorAll('.required-checkboxes .checkbox-row');
                    checkboxRows.forEach((row) => {
                        errorShake(row);
                    });
                }
            }
            if (input.hasAttribute('required')) {
                if (input.name == 'positive_action_other') {
                    let parent = input.closest('.form-group');
                    if (!parent.classList.contains('disabled')) {
                        if (!input.value) {
                            valid = false;
                            errorShake(input);
                        }
                    }
                } else if (!input.value) {
                    valid = false;

                    // if input.type contains 'select'
                    if (input.type == 'select-one') {
                        let select2 = input.nextElementSibling.querySelector('.select2-selection');
                        errorShake(select2);
                    }
                    else {
                        errorShake(input);
                    }
                }
            }
        });
        return valid;
    }

    function errorShake(element) {
        element.classList.add('shake');
        setTimeout(() => {
            element.classList.remove('shake');
        }, 500);

        element.classList.add('is-invalid');
        setTimeout(() => {
            element.classList.remove('is-invalid');
        }, 1000);
    }

    function fadeOutCurrent(next = true) {
        console.log('fadeOutCurrent');

        transitioning = true;
        let currentPage = document.querySelector(`#FEEDBACK .page[data-page="${currentPageNumber}"]`);
        currentPage.classList.add('fade-out');
        setTimeout(() => {
            currentPage.style.display = 'none';
            currentPage.classList.remove('fade-out');
        }, fadeSpeed);

        if (currentPageNumber == 1) {
            skipButton.classList.add('fade-out');
            setTimeout(() => {
                skipButton.style.display = 'none';
                skipButton.classList.remove('fade-out');
            }, fadeSpeed);
        }
        if (!next && currentPageNumber == 2) {
            backButton.classList.add('fade-out');
            setTimeout(() => {
                backButton.style.display = 'none';
                backButton.classList.remove('fade-out');
            }, fadeSpeed);
        }
        if (next && currentPageNumber + 1 == lastPageNumber) {
            nextButton.classList.add('fade-out');
            setTimeout(() => {
                nextButton.style.display = 'none';
                nextButton.classList.remove('fade-out');
            }, fadeSpeed);
        }
        if (!next && currentPageNumber == lastPageNumber) {
            finishButton.classList.add('fade-out');
            setTimeout(() => {
                finishButton.style.display = 'none';
                finishButton.classList.remove('fade-out');
            }, fadeSpeed);
        }
    }

    function fadeInNext(nextPageNumber) {
        console.log('fadeInNext', nextPageNumber);
        let nextPage = document.querySelector(`#FEEDBACK .page[data-page="${nextPageNumber}"]`);


        nextPage.classList.add('fade-in');
        nextPage.style.display = 'block';
        setTimeout(() => {
            nextPage.classList.remove('fade-in');

            transitioning = false;
        }, fadeSpeed);

        if (nextPageNumber === 1) {
            skipButton.classList.add('fade-in');
            skipButton.style.display = 'block';
            setTimeout(() => {
                skipButton.classList.remove('fade-in');
            }, fadeSpeed);
        }
        if (nextPageNumber == 2 && currentPageNumber != 3) {
            backButton.classList.add('fade-in');
            backButton.style.display = 'block';
            setTimeout(() => {
                backButton.classList.remove('fade-in');
            }, fadeSpeed);
        }
        if (nextPageNumber == lastPageNumber) {
            finishButton.classList.add('fade-in');
            finishButton.style.display = 'block';
            setTimeout(() => {
                finishButton.classList.remove('fade-in');
            }, fadeSpeed);
        }
        if (nextPageNumber == lastPageNumber - 1 && nextButton.style.display == 'none') {
            nextButton.classList.add('fade-in');
            nextButton.style.display = 'block';
            setTimeout(() => {
                nextButton.classList.remove('fade-in');
            }, fadeSpeed);
        }


        currentPageNumber = nextPageNumber;
    }
}
